import { jsxs as p, Fragment as a, jsx as e } from "react/jsx-runtime";
import f from "../list-loader-and-help-text/list-loader-and-help-text.js";
import { List as i } from "../list/list.js";
const l = ({
  isListingStations: r,
  isLoadingGeolocation: t,
  stationRows: o,
  selectedStationCode: m,
  geolocation: d,
  onClickStation: s
}) => /* @__PURE__ */ p(a, { children: [
  /* @__PURE__ */ e(f, { isListingStations: r, isLoadingGeolocation: t }),
  r && /* @__PURE__ */ e(
    i,
    {
      items: o,
      onClickStation: s,
      geolocation: d,
      selectedStationCode: m
    }
  )
] });
export {
  l as default
};
